import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, isRef as _isRef, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = ["numeric-id"]
const _hoisted_2 = { class: "numeric-card__title-overlay numeric-card__title-overlay--icon" }
const _hoisted_3 = {
  key: 0,
  class: "numeric-card__block numeric-card__block--status"
}
const _hoisted_4 = { class: "numeric-card__block numeric-card__block--completion" }
const _hoisted_5 = { class: "numeric-card__assigned" }
const _hoisted_6 = { class: "numeric-card__completion" }

import VUserCard from './VUserCard.vue';
import VTitledValue from './VTitledValue.vue';

// Other
import { PropType, ref } from 'vue';
import INumeric from '@/core/Models/INumeric';
import { useNumericCompletion, useNumericCard, useNumericContextMenu } from '@/mixins/NumericApi';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';
import VTaskStatus from '@/components/VTaskStatus.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'VNumericCard',
  props: {
    goal: { type: Object as PropType<INumeric>, required: true },
},
  setup(__props) {

// Svg
// ...

// Components
const { t } = useI18n();
const props = __props;
const { goal: numeric } = toRefs(props);
const { isSelected } = useNumericCard(numeric);
const { completion } = useNumericCompletion(numeric);
const { openContextMenu } = useNumericContextMenu(numeric);

let isCollapsed = ref(true);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["numeric-card numeric-goal-selector", {
            'numeric-card--selected': _unref(isSelected),
            'numeric-card--warning': _unref(completion).current.waiting,
            'numeric-card--success': _unref(completion).current.success,
            'numeric-card--archived': !!_unref(numeric).archivedAt,
        }]),
    "numeric-id": _unref(numeric).id,
    onContextmenu: _cache[1] || (_cache[1] = ($event: any) => (_unref(openContextMenu)($event, _unref(numeric))))
  }, [
    _createElementVNode("div", {
      class: "numeric-card__block numeric-card__block--title",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(isCollapsed) //@ts-ignore
 ? isCollapsed.value = !_unref(isCollapsed) : isCollapsed = !_unref(isCollapsed)))
    }, [
      _createElementVNode("span", _hoisted_2, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(completion).current.icon), { class: "svg svg--150" })),
        _createTextVNode(" " + _toDisplayString(_unref(numeric).year), 1)
      ]),
      _createElementVNode("p", {
        class: _normalizeClass(["numeric-card__title", {
                    'numeric-card__title--blurry': !_unref(numeric).name,
                    'numeric-card__title--negative': !!_unref(numeric).archivedAt,
                }])
      }, _toDisplayString(_unref(numeric).name ? _unref(numeric).name : _unref(t)('untitled')), 3)
    ]),
    (!!_unref(numeric).archivedAt)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(VTaskStatus, { task: _unref(numeric) }, null, 8, ["task"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_unref(numeric).assigneeId)
          ? (_openBlock(), _createBlock(VUserCard, {
              key: 0,
              user: _unref(numeric).assigneeId
            }, null, 8, ["user"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(VTitledValue, _normalizeProps(_guardReactiveProps(_unref(completion).quarter1)), null, 16),
        _createVNode(VTitledValue, _normalizeProps(_guardReactiveProps(_unref(completion).quarter2)), null, 16),
        _createVNode(VTitledValue, _normalizeProps(_guardReactiveProps(_unref(completion).quarter3)), null, 16),
        _createVNode(VTitledValue, _normalizeProps(_guardReactiveProps(_unref(completion).quarter4)), null, 16)
      ])
    ])
  ], 42, _hoisted_1))
}
}

})